/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { ModalWindow } from '../../../modal';
import { useClickController } from '../../internal';
/**
 * Компонент подсказки в виде модального окна
 *
 * @export
 * @param {ITooltipMobileProps} props
 * @returns
 */
export function TooltipMobile(props) {
  var title = props.title,
    header = props.header,
    children = props.children;
  var _useClickController = useClickController(props),
    childrenProps = _useClickController.childrenProps,
    open = _useClickController.open,
    handleClose = _useClickController.handleClose;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.cloneElement(children, childrenProps), /*#__PURE__*/React.createElement(ModalWindow, {
    open: open,
    onClose: handleClose,
    title: header,
    content: title
  }));
}